module.exports = __webpack_public_path__ + "img/pd.b29888ca.png";